<template>
  <AuthLayout title="Register" heading="Sign up for an account">
    <template #link>
      <LinkBase :href="route('login')"
        >sign-in to your existing account</LinkBase
      >
    </template>
    <form class="space-y-4" @submit.prevent="form.post(route('register'))">
      <div>
        <InputGroup
          v-model="form.name"
          label="Full name"
          :error="form.errors.name"
          autocomplete="name"
          required
          autofocus
        />
      </div>

      <div>
        <InputGroup
          v-model="form.email"
          type="email"
          label="Email address"
          :error="form.errors.email"
          autocomplete="email"
          required
        />
      </div>

      <div>
        <InputGroup
          v-model="form.password"
          type="password"
          label="Password"
          :error="form.errors.password"
          autocomplete="new-password"
          required
        />
      </div>

      <div>
        <InputGroup
          v-model="form.password_confirmation"
          type="password"
          label="Confirm password"
          :error="form.errors.password_confirmation"
          autocomplete="new-password"
          required
        />
      </div>
      <div>
        <ButtonBase
          type="submit"
          class="w-full justify-center"
          :processing="form.processing"
          >Sign Up</ButtonBase
        >
      </div>
    </form>
  </AuthLayout>
</template>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3'

import AuthLayout from '@/Layouts/AuthLayout.vue'
import InputGroup from '@/Common/Forms/Inputs/InputGroup.vue'
import LinkBase from '@/Common/Text/LinkBase.vue'
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'

const form = useForm({
  name: null,
  email: null,
  password: null,
  password_confirmation: null,
})
</script>
